//Generated file - DO NOT MODIFY
import { observable, computed, action } from 'mobx';
import { serializable, list, primitive, identifier, update, deserialize } from 'serializr';
import _ from 'lodash';

export const emailTemplateSettingsSchema = () => ({
    serializer: (source) => JSON.stringify(source),
    deserializer: (json, callback) => callback(null, typeof json === 'string' ? JSON.parse(json) : json),
});

export default class EmailTemplateBase {
    @serializable(identifier()) @observable id = 0;
    @serializable @observable name = '';
    @serializable @observable subject = '';
    @serializable @observable body = '';
    @serializable @observable isdeleted = false;
    @serializable(emailTemplateSettingsSchema()) @observable settings = {};

    static get __name__() {
        return 'EmailTemplate';
    }

    constructor(id = 0, name = '', subject = '', body = '', isdeleted=false,settings = {}) {
        this.id = observable();
        this.id = id;
        this.name = observable();
        this.name = name;
        this.subject = observable();
        this.subject = subject;
        this.body = observable();
        this.body = body;
        this.isdeleted = observable();
        this.isdeleted = isdeleted;
        this.settings = observable();
        this.settings = settings;
    }
}



// WEBPACK FOOTER //
// ./src/shared/emailtemplate-base.js